"use client";

import { useTranslations } from "next-intl";

import { pageConfig } from "@/config/pages.config";
import { useRouter } from "@/i18n/routing";
import { useModalStore } from "@/store/modal.store";
import Button from "@/ui/Button";
import { Divider } from "@/ui/Divider";
import { cn } from "@/utils/cn";
import { ModalHeader } from "@/widgets/Modal/Header";

import styles from "./style.module.scss";

export const AuthRequired = () => {
  const t = useTranslations();
  const { closeModal } = useModalStore();
  const router = useRouter();

  const handleClose = () => {
    closeModal();
  };

  const handleGoToRegister = () => {
    closeModal();
    router.push(pageConfig.login);
  };

  return (
    <div className={cn(styles.wrapper, "relative")}>
      <ModalHeader title={t("You must be logged in to add an object")} />
      <Divider />
      <div className={cn(styles.buttonContainer, "py-12 px-16")}>
        <Button
          color="white"
          radius="md"
          fullWidth
          onClick={handleClose}
          className="h-[5.4rem]"
        >
          {t("Return")}
        </Button>
        <Button
          color="red"
          radius="md"
          fullWidth
          onClick={handleGoToRegister}
          className="h-[5.4rem]"
        >
          {t("Go to authorization")}
        </Button>
      </div>
    </div>
  );
};

export default AuthRequired;
